import script from "./FeatureShowcase.vue?vue&type=script&setup=true&lang=js"
export * from "./FeatureShowcase.vue?vue&type=script&setup=true&lang=js"

import "./FeatureShowcase.vue?vue&type=style&index=0&id=be3ebe8c&scoped=true&lang=css"

import exportComponent from "/Users/yousefgadban/Developer/applates/applatesLandingVue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-be3ebe8c"]])

export default __exports__